import * as constants from "./constants";

const initialState = {
  allMissing: [],
  fetchingLoading: true,
  updateLoading: false,
  // totalRecords: 0,
  isAdding: false,
  search: {},
};

const MissingEnrolmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_MISSING_ENROLMENT:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_MISSING_ENROLMENT_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allMissing: action.payload,
        isAdding: false,
      };
    case constants.FETCH_MISSING_ENROLMENT_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };

    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    case constants.SET_MISSING_ENROLMENT_MANAGER_STATE:
      const { search } = state;

      localStorage.setItem(
        "missingEnrolmentManagerState",
        JSON.stringify({ search, ...action.data })
      );
      return {
        ...state,
        ...action.data,
      };

    default:
      return state;
  }
};

export default MissingEnrolmentReducer;
